<template>
    <v-card class="stat-card hover-card pa-4">
        <div class="card-content">
            <div class="card-text">
                <div class="card-title"><v-btn variant="outlined"
                        class="rounded-pill text-white border-white text-none pill-btn">{{ title }}</v-btn></div>
                <div class="card-value">{{ value }}</div>
                <div class="card-subtext" v-if="subtext">{{ subtext }}<v-icon size="18"
                        class="ms-2 cursor-pointer hover:opacity-70" @click="copyToClipboard(subtext)">
                        {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
                    </v-icon></div>
            </div>
            <div class="d-flex justify-center gap-6 mt-4" style="margin-bottom: 3%; gap: 1%;">
                <!-- Add Money -->
                <!-- <v-btn variant="flat" @click="$emit('open-funding')" color="white" class="rounded-pill text-none d-flex align-center px-3">
                    Add Money
                    <v-icon class="ms-2" color="green" size="20">mdi-arrow-bottom-left-bold-box-outline</v-icon>
                </v-btn> -->

                <v-menu location="bottom end" offset="12">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" variant="flat" color="white"
                            class="rounded-pill text-none d-flex align-center px-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="#3fd907">
                                <path
                                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM8.64 7.15C8.93 6.86 9.41 6.86 9.7 7.15L14.08 11.53V9.1C14.08 8.69 14.42 8.35 14.83 8.35C15.24 8.35 15.58 8.69 15.58 9.1V13.34C15.58 13.44 15.56 13.53 15.52 13.63C15.44 13.81 15.3 13.96 15.11 14.04C15.02 14.08 14.92 14.1 14.82 14.1H10.58C10.17 14.1 9.83 13.76 9.83 13.35C9.83 12.94 10.17 12.6 10.58 12.6H13.01L8.64 8.21C8.35 7.92 8.35 7.45 8.64 7.15ZM18.24 17.22C16.23 17.89 14.12 18.23 12 18.23C9.88 18.23 7.77 17.89 5.76 17.22C5.37 17.09 5.16 16.66 5.29 16.27C5.42 15.88 5.84 15.66 6.24 15.8C9.96 17.04 14.05 17.04 17.77 15.8C18.16 15.67 18.59 15.88 18.72 16.27C18.84 16.67 18.63 17.09 18.24 17.22Z"
                                    fill="white" style="fill: var(--fillg);" />
                            </svg>
                            Add Money

                            <!-- <v-icon class="ms-2" color="green" size="20">
                                mdi-arrow-bottom-left-bold-box-outline
                            </v-icon> -->

                            <v-icon class="ms-1" size="18">
                                mdi-chevron-down
                            </v-icon>
                        </v-btn>
                    </template>

                    <v-list min-width="220">

                        <!-- Online Payment -->
                        <v-list-item @click="openOnlinePayment">
                            <template #prepend>
                                <v-icon color="green">
                                    mdi-credit-card-outline
                                </v-icon>
                            </template>

                            <v-list-item-title>
                                Online Payment
                            </v-list-item-title>

                            <v-list-item-subtitle>
                                Pay with Paystack
                            </v-list-item-subtitle>
                        </v-list-item>

                        <!-- Bank Transfer -->
                        <v-list-item @click="$emit('open-funding')">
                            <template #prepend>
                                <v-icon color="blue">
                                    mdi-bank-transfer
                                </v-icon>
                            </template>

                            <v-list-item-title>
                                Bank Transfer
                            </v-list-item-title>

                            <v-list-item-subtitle>
                                Manual account funding
                            </v-list-item-subtitle>
                        </v-list-item>

                    </v-list>
                </v-menu>

                <!-- Withdraw -->
                <v-btn variant="flat" color="white" class="rounded-pill text-none d-flex align-center px-3"
                    @click="$emit('open-withdrawal')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#f55c36">
                        <path
                            d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM8.64 12.81L13.02 8.43H10.59C10.18 8.43 9.84 8.09 9.84 7.68C9.84 7.27 10.18 6.93 10.59 6.93H14.83C14.93 6.93 15.02 6.95 15.12 6.99C15.3 7.07 15.45 7.21 15.53 7.4C15.57 7.49 15.59 7.59 15.59 7.69V11.93C15.59 12.34 15.25 12.68 14.84 12.68C14.43 12.68 14.09 12.34 14.09 11.93V9.5L9.7 13.87C9.55 14.02 9.36 14.09 9.17 14.09C8.98 14.09 8.79 14.02 8.64 13.87C8.35 13.58 8.35 13.1 8.64 12.81ZM18.24 17.22C16.23 17.89 14.12 18.23 12 18.23C9.88 18.23 7.77 17.89 5.76 17.22C5.37 17.09 5.16 16.66 5.29 16.27C5.42 15.88 5.84 15.66 6.24 15.8C9.96 17.04 14.05 17.04 17.77 15.8C18.16 15.67 18.59 15.88 18.72 16.27C18.84 16.67 18.63 17.09 18.24 17.22Z"
                            fill="white" style="fill: var(--fillg);" />
                    </svg>
                    Send Money
                    <!-- <v-icon class="ms-2" color="red" size="20">mdi-arrow-top-right-bold-box-outline</v-icon> -->
                </v-btn>

            </div>
            <!--Input fund--->
            <v-dialog v-model="paymentDialog" max-width="400">
                <v-card class="pa-6">

                    <v-card-title class="text-center">
                        Enter Amount
                    </v-card-title>

                    <v-text-field v-model="amount" type="number" label="Amount (₦)" variant="outlined" />

                    <div class="d-flex justify-end gap-2 mt-4">
                        <v-btn variant="text" @click="paymentDialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="green" :disabled="!amount || amount <= 0" @click="startPaystack">
                            Pay Now
                        </v-btn>
                    </div>

                </v-card>
            </v-dialog>
            <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
                snackbar.message }}
                <template #actions>
                    <v-btn variant="text" @click="snackbar.show = false">
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-card>
</template>

<script setup>
import { VCard } from 'vuetify/components'
import { ref } from "vue"
import PaystackPop from '@paystack/inline-js'
import { useAuthStore } from "@/store/auth"
import { useDashStore } from '@/store/dashboard'

defineProps({
    title: String,
    value: [String, Number],
    subtext: String,
    icon: { type: String },
    iconColor: { type: String, default: '#0f2638 ' },
    textColor: { type: String, default: '#64cf69' },
    background: {
        type: String,
        default: '#FFFFFF',
    },
})

const auth = useAuthStore()
const dash = useDashStore()

const copied = ref(false)
const paymentDialog = ref(false)
const amount = ref(null)

//snack bar notification
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}

const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text)
        copied.value = true

        setTimeout(() => {
            copied.value = false
        }, 1500)
    } catch (err) {
        console.error(err)
    }
}

//payment dialog
const openOnlinePayment = () => {
    paymentDialog.value = true
}

const startPaystack = () => {
    // open paystack modal or payment dialog
    const popup = new PaystackPop()

    popup.newTransaction({
        key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY,
        email: auth.user?.user?.email,
        amount: amount.value * 100, // amount in kobo i.e naira * 100

        currency: "NGN",

        reference: `TXN_${Date.now()}`,

        onSuccess: async (transaction) => {
            console.log("Payment success:", transaction)

            // Optional: verify transaction on backend
            // await verifyPayment(transaction.reference)

            //alert("Payment successful!")
            showSnackbar("Payment successful!", "success")
            paymentDialog.value = false

            // poll wallet update
            let attempts = 0

            const interval = setInterval(async () => {
                attempts++

                await dash.loadUser()

                const updatedBalance = dash.user?.user?.wallet?.balance

                console.log("Checking updated balance:", updatedBalance)

                // stop after balance updates
                if (updatedBalance > 0 || attempts >= 5) {
                    clearInterval(interval)
                }
            }, 2000)


        },

        onCancel: () => {
            paymentDialog.value = false
            showSnackbar("Payment cancelled", "error")
            console.log("Payment cancelled")
        },

        onLoad: () => {
            console.log("Paystack loaded")
        },

        onError: (error) => {
            showSnackbar("Paystack error", "error")
            console.log("Paystack error:", error)
        }
    })
}
</script>

<style scoped>
.stat-card {
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    min-height: 140px;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    background: #112830;
    color: #FFFFFF;
}

.hover-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.stat-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.stat-content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.stat-text {
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
    /* justify-content: center; */
}

.card-text {
    margin-bottom: 5%;
}

.card-title {
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 500;
    width: 100%;

}

.card-value {
    font-size: 28px;
    font-weight: 700;
    color: #FFFFFF;
    margin: 4px 0;
}

.card-subtext {
    font-size: 13px;
    color: #FFFFFF;
    font-weight: 500;
}

.stat-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.pill-btn {
    display: inline-block;
    padding: 8px 16px;
    border: 1px solid #fff;
    border-radius: 999px;
    background: transparent;
    transition: all 0.3s ease;
    width: 70%;
    margin: 3% 5%;
}
</style>